<div class="alert p-3 d-flex flex-row">
    <div>
        <mat-icon>{{ icon }}</mat-icon>
    </div>
    <p class="ms-3 mb-0"><ng-content></ng-content></p>
</div>
